import type React from "react";

type Props = {label: string; note?: React.ReactNode; children: React.ReactNode};

/** One labelled value of a fact grid (`.ci-kv`), with an optional note under it. */
export const KeyValue: React.FC<Props> = ({label, note, children}) => (
    <div>
        <span className="ci-kv-l">{label}</span>
        <div className="ci-kv-v">{children}</div>
        {note && <span className="ci-kv-n">{note}</span>}
    </div>
);
